<template>
  <div v-if="purchase.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('Purchases', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="
              ($route.path.startsWith('/purchases-examine')
                ? '/#/purchases-examine/'
                : '/#/purchases/detail/') + purchase.id
            "
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("PurchasesList.actions.detail") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("PurchasesList.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 导出 -->
      <v-tooltip
        top
        v-if="
          showExport &&
          $permission.permissionAllow('Purchases', 'purchaseExport')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="purchaseExport()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("PurchasesList.actions.export") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasesList.actions.export") }}</span>
      </v-tooltip>
      <!-- 验收导出 -->
      <v-tooltip
        top
        v-if="
          showExamineExport &&
          $permission.permissionAllow('Purchases', 'purchaseExamineExport')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="purchaseExamineExport()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("PurchasesList.actions.export") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasesList.actions.export") }}</span>
      </v-tooltip>
      <!-- 编辑 -->
      <v-tooltip
        top
        v-if="showEdit && $permission.permissionAllow('Purchases', 'edit')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('edit')
                  : $router.push('/purchases/detail/' + purchase.id + '/edit');
              })
            "
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("PurchasesList.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.editInfo", [$t("PurchasesList.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 验收 -->
      <v-tooltip
        top
        v-if="
          showExamine && $permission.permissionAllow('Purchases', 'examine')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="examine()"
          >
            <!-- $permission.checkAccountExpired().then(() => {
                $router.push('/purchases-examine/' + purchase.id + '/examine');
              }) -->
            <v-icon x-small class="pe-1">far fa-check-square</v-icon>
            {{ $t("PurchasesList.actions.examine") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasesList.actions.examine") }}</span>
      </v-tooltip>
      <!-- 平台供应商验收 -->
      <v-tooltip
        top
        v-if="showSupplierExamine && $permission.permissionAllow('Purchases', 'examine')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="print"
            class="px-2 me-2 mb-1"
            :href="'/#/purchases-examine/supplier/' + purchase.id"
          >
            <v-icon x-small class="pe-1">far fa-check-square</v-icon>
            {{ $t("PurchasesList.actions.examine") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasesList.actions.examine") }}</span>
      </v-tooltip>
      <!-- 物流 -->
      <v-tooltip
        top
        v-if="showLogistic"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            :outlined="!purchase.logistics_json.logistics_name"
            color="orange"
            class="px-2 me-2 mb-1"
            @click.stop="logisticAlert = true"
          >
            {{ $t("Distribution.actions.logistic") }}
          </v-btn>
        </template>
        <span>{{ $t("Distribution.actions.logistic") }}</span>
      </v-tooltip>
      <!-- 完成 -->
      <v-tooltip
        top
        v-if="showFinish && $permission.permissionAllow('Purchases', 'examine')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="warning"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                $router.push('/purchases-examine/' + purchase.id + '/finish');
              })
            "
          >
            <v-icon x-small class="pe-1">far fa-check-circle</v-icon>
            {{ $t("PurchasesList.actions.finish") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasesList.actions.finish") }}</span>
      </v-tooltip>
      <!-- 确认 -->
      <v-tooltip
        top
        v-if="
          showConfirm && $permission.permissionAllow('Purchases', 'confirm')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="print"
            class="px-2 me-2 mb-1"
            :href="'/#/purchases/detail/' + purchase.id + '/confirm'"
          >
            <v-icon x-small class="pe-1">fa-location-arrow</v-icon>
            {{ $t("PurchasesList.actions.confirm") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasesList.actions.confirm") }}</span>
      </v-tooltip>
      <!-- 取消 -->
      <v-tooltip
        top
        v-if="showCancel && $permission.permissionAllow('Purchases', 'cancel')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancel = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("PurchasesList.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasesList.actions.cancel") }}</span>
      </v-tooltip>
      <!-- 通知TODO:缺接口 -->
      <v-tooltip
        top
        v-if="showNotice && $permission.permissionAllow('Purchases', 'notice')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="info"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-envelope</v-icon>
            {{ $t("PurchasesList.actions.envelope") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasesList.actions.envelope") }}</span>
      </v-tooltip>
      <!-- 复制 -->
      <v-tooltip
        top
        v-if="showCopy && $permission.permissionAllow('Purchases', 'copy')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="clone = true"
          >
            <v-icon x-small class="pe-1">fa-clone</v-icon>
            {{ $t("PurchasesList.actions.copy") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasesList.actions.copy") }}</span>
      </v-tooltip>
      <!-- 打印 -->
      <v-tooltip
        top
        v-if="showPrint && $permission.permissionAllow('Purchases', 'print')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="doPrint('purchasePrint')"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("PurchasesList.actions.print") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasesList.actions.print") }}</span>
      </v-tooltip>

      <!-- 云打印 -->
      <v-tooltip
        top
        v-if="
          showPrint && $permission.permissionAllow('Purchases', 'print') &&
          $permission.permissionAllow('CloudPrints', 'index') &&
          settings && settings.cloud_print_enable
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="doCloudPrint('adminPurchase')"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.cloud_print") }}
          </v-btn>
        </template>
        <span>{{ $t("Print.cloud_print") }}</span>
      </v-tooltip>

      <!-- 后议价 -->
      <v-btn
        v-if="
          showNegotiate &&
          $permission.permissionAllow(
            'Purchases',
            'getNegotiatePriceDetails'
          ) &&
          purchase.negotiate_price_flg == 1
        "
        small
        dark
        color="info"
        class="px-2 me-2 mb-1"
        @click="
          $router.push({
            path: '/purchases/batch-negotiate-price',
            query: {
              purchase_ids: encodeURI(purchase.id),
            },
          })
        "
      >
        {{ $t("PurchasesList.actions.NegotiatePrices") }}
      </v-btn>
      <v-btn
        v-if="showPurchaseToSupplierOrder"
        small
        dark
        color="warning"
        class="px-2 me-2 mb-1"
        @click="purchaseToSupplierOrder();"
      >
        {{ $t("PurchasesList.actions.sync") }}
      </v-btn>
    </v-sheet>

    <!-- 弹窗 -->
    <DialogPurchases
      v-model="cancel"
      cancel-mode
      :label="$t('PurchasesList.Fields.purchase_code')"
      :code="purchase.purchase_code"
      @confirm="
        doAction('cancel');
        cancel = false;
      "
    />
    <DialogClonePurchase
      v-model="clone"
      clone-mode
      @confirm="
        doAction('clone');
        clone = false;
      "
    />
    <v-dialog persistent v-model="dialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          {{ purchase.third_return ? purchase.third_return.msg : "" }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="purchase.third_return && purchase.third_return.status == 3"
            color="accent"
            outlined
            @click="
              pushAgain();
              dialog = false;
            "
          >
            {{ $t("StockOrderOUT.actions.pushAgain") }}
          </v-btn>
          <v-btn color="secondary" outlined depressed @click="dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <LogisticAlert
      v-model="logisticAlert"
      :distribution="Object.assign({}, purchase.logistics_json, {
        logistics_img_url : purchase.logistics_img_url})"
    />
    <SyncErrorResult
      v-model="syncErrorDialog"
      :errorData="syncErrorData"
    />
  </div>
</template>

<script>
import DialogPurchases from "@/components/plugins/DialogPurchases";
import DialogClonePurchase from "@/components/plugins/DialogClonePurchase";
import Purchases from "@/api/purchases";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import LogisticAlert from "@/components/distributions/plugins/LogisticAlert";
import SyncErrorResult from "./SyncErrorResult"
import {mapState} from "vuex";
import i18n from "@/i18n";

export default {
  name: "StockDetailsActions",

  props: {
    detailMode: Boolean,
    purchase: Object,
    showView: Boolean,
    showNegotiate: Boolean,
    showPrint: Boolean,
    showFinish: Boolean,
    showExamine: Boolean,
    showExport: Boolean,
    showConfirm: Boolean,
    showEdit: Boolean,
    showCancel: Boolean,
    showNotice: Boolean,
    showCopy: Boolean,
    showExamineExport: Boolean,
    showLogistic: Boolean,
    showPurchaseToSupplierOrder: Boolean,
    showSupplierExamine: Boolean,
  },
  components: {
    DialogPurchases,
    DialogClonePurchase,
    LogisticAlert,
    SyncErrorResult,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    logisticAlert: false,
    cancel: false,
    clone: false,
    cancelProhibit: false,
    cancelUnProhibit: false,
    dialog: false,
    syncErrorDialog: false,
    syncErrorData: [],
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "cancel") return Purchases.cancel(this.purchase.id);
      if (mode == "clone") return Purchases.clone(this.purchase.id);
    },
    purchaseExport() {
      Purchases.exports(this.purchase.id);
    },
    purchaseExamineExport() {
      Purchases.examineExport(this.purchase.id);
    },
    // 操作
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$emit("done");
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          switch (mode) {
            case "purchasePrint":
              this.$router.push("/print/purchase-print/" + this.purchase.id);
              break;
          }
        }.bind(this)
      );
    },
    doCloudPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          if (mode == 'adminPurchase') {
            //获取单据详情
            Purchases.purchasePrint(this.purchase.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let purchase = response.data.purchase;
                  purchase.purchase_details = purchase.purchase_details.map((detail) => {
                    if (detail.negotiate_price_flg == 1) {
                      // 显示后议价
                      // 单价
                      detail.price = this.$t("PurchasesDetail.purchaseFields.negotiatePrices");
                      // 采购金额
                      detail.total = this.$t("PurchasesDetail.purchaseFields.negotiatePrices");
                    }
                    return detail;
                  });
                  CloudPrintTemplates.print({
                    print_template_code: mode,
                    object: purchase
                  })
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    examine() {
      if (
        this.purchase.third_return &&
        this.purchase.third_return.push_platform == 1010
      ) {
        this.dialog = true;
      } else {
        this.$router.push(
          "/purchases-examine/" + this.purchase.id + "/examine"
        );
      }
    },
    pushAgain() {
      Purchases.pushAgain(this.purchase.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$emit("done");
          }
        }.bind(this)
      );
    },
    purchaseToSupplierOrder() {
      Purchases.purchaseToSupplierOrder(this.purchase.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("SupplierMaterials.syncSuccessMgs"));
              this.$emit("done");
            }else {
              if (response.data.error.code == "ERR151" && response.data.data) {
                this.syncErrorData = response.data.data
                this.syncErrorDialog = true;
              }
            }
          }.bind(this)
      );
    },
  },
};
</script>